
(()=>{
  const path=window.location.pathname.replace(/\/+$/,"");
  if(path==="/collections/free-resources"){
    const hero=document.querySelector("body.agv2-free-resources .collection-hero");
    const container=document.querySelector("body.agv2-free-resources .product-grid-container");
    if(hero&&!document.querySelector(".agv2-resource-recommended")){
      const source=hero.querySelector(".agv2-collection-hero__description-desktop section[aria-label='Recommended third-party tools']");
      const card=source||document.createElement("section");
      if(!source){
        card.setAttribute("aria-label","Recommended third-party tools");
        card.innerHTML='<p style="margin:0 0 6px;color:#942180;font-size:11px;font-weight:900;letter-spacing:.15em;text-transform:uppercase">Beyond the free downloads</p><h3>Recommended Tools</h3><p>Looking for the platforms and services behind the systems? Explore Alicia’s curated third-party tools, with partnership and affiliate relationships disclosed.</p><a href="/pages/recommended-tools">Explore Recommended Tools <span aria-hidden="true">→</span></a>';
      }
      card.classList.add("agv2-resource-recommended");
      const libraryHead=container?.querySelector(".agv2-resource-library-head");
      if(libraryHead) libraryHead.insertAdjacentElement("beforebegin",card);
      else if(container) container.insertAdjacentElement("afterbegin",card);
      else hero.insertAdjacentElement("afterend",card);
    }
  }
  if(path!=="/pages/recommended-tools")return;
  const root=document.querySelector("#ag-tools");
  const nav=root?.querySelector(".agt-category-nav");
  if(!nav||nav.dataset.agPolishFilters==="1")return;
  nav.dataset.agPolishFilters="1";
  nav.setAttribute("aria-label","Filter recommended tools");
  const sections=[...root.querySelectorAll(".agt-section")];
  const entries=sections.flatMap(section=>[...section.querySelectorAll(".agt-tool")].map(card=>({
    section,card,category:section.id,
    title:(card.querySelector("h3")?.textContent||"").trim().toLowerCase(),
    label:(card.querySelector(".agt-tool-badge")?.textContent||"").toLowerCase()
  })));
  const partnered=new Set(["klaviyo","shopify"]);
  const monetized=new Set(["klaviyo","airtable","siteground"]);
  const currently=new Set(["klaviyo","airtable","shopify","chatgpt","loom","canva","zoom workplace pro","google workspace","google analytics","vidiq","medium","metricool","jetpack for wordpress","siteground","slack","trello","speechify","semrush","zoho one","google search console","looker studio","google business profile"]);
  const oldLinks=[...nav.querySelectorAll("a[href^='#']")].map(a=>({
    category:a.getAttribute("href").slice(1),title:a.textContent.trim()
  }));
  const opts=[
    {filter:"all",title:"All Tools"},
    {filter:"use",title:"Tools I Use"},
    {filter:"partner",title:"Partner Tools"},
    {filter:"affiliate",title:"Affiliate & Referral"},
    ...oldLinks.filter(x=>sections.some(s=>s.id===x.category)).map(x=>({filter:x.category,title:x.title}))
  ];
  nav.replaceChildren();
  const buttons=opts.map(item=>{
    const button=document.createElement("button");
    button.type="button";
    button.className="agt-filter-chip";
    button.setAttribute("aria-pressed","false");
    button.textContent=item.title;
    button.dataset.agFilter=item.filter;
    nav.append(button);
    return button;
  });
  const status=document.createElement("p");
  status.className="agt-filter-status";
  status.setAttribute("role","status");
  status.setAttribute("aria-live","polite");
  nav.insertAdjacentElement("afterend",status);
  function apply(filter,button){
    let count=0;
    entries.forEach(entry=>{
      const show=filter==="all"||(filter==="use"&&currently.has(entry.title))||
        (filter==="partner"&&partnered.has(entry.title))||
        (filter==="affiliate"&&monetized.has(entry.title))||
        filter===entry.category;
      entry.card.hidden=!show;
      if(show)count++;
    });
    sections.forEach(section=>{
      section.hidden=!entries.some(entry=>entry.section===section&&!entry.card.hidden);
    });
    buttons.forEach(b=>b.setAttribute("aria-pressed",String(b===button)));
    let caption;
    if(filter==="all") caption=count+" total "+(count===1?"tool":"tools");
    else if(filter==="use") caption=count+" "+(count===1?"tool I use":"tools I use");
    else if(filter==="partner") caption=count+" "+(count===1?"partner tool":"partner tools");
    else if(filter==="affiliate") caption=count+" "+(count===1?"affiliate & referral tool":"affiliate & referral tools");
    else caption=count+" "+(button?.textContent?.trim()||"category")+" "+(count===1?"tool":"tools");
    status.textContent=caption;
    if(button){
      const left=button.offsetLeft-nav.offsetLeft;
      const center=left-(nav.clientWidth-button.offsetWidth)/2;
      nav.scrollTo({left:Math.max(0,center),behavior:window.matchMedia("(prefers-reduced-motion:reduce)").matches?"instant":"smooth"});
    }
  }
  buttons.forEach(b=>b.addEventListener("click",()=>apply(b.dataset.agFilter,b)));
  const initial=window.location.hash.slice(1);
  const chosen=buttons.find(b=>b.dataset.agFilter===initial)||buttons[0];
  apply(chosen.dataset.agFilter,chosen);
})();
